import { useId } from 'react';
import { Link } from '@tanstack/react-router';
import { Icone } from '../Icone';
import { useFecharAoNavegar } from './fecharAoNavegar';

/**
 * Menu da conta no topo. Junta o que não cabe na barra do celular sem virar
 * ícone mudo: cada item tem nome por extenso. Sair é BOTÃO num formulário --
 * revoga a sessão, e link que muda estado é disparado por pré-carregamento.
 */
export function MenuConta({
  nome, saindo, aoSair, trocaDeContexto, cadastroPro, painel,
}: {
  nome: string;
  saindo: boolean;
  aoSair: () => void;
  /** Contratar/Trabalhar para quem é profissional; no celular só aparece aqui. */
  trocaDeContexto?: { para: 'cliente' | 'profissional' };
  /** Quem ainda não é profissional verificado: no celular a lateral some, então o convite mora aqui. */
  cadastroPro?: { rotulo: string };
  /** Conta de alguém da equipe: atalho de volta ao painel. */
  painel?: boolean;
}) {
  const id = useId();
  const idMenu = `${id}-menu`;
  const ref = useFecharAoNavegar<HTMLDivElement>();
  return (
    <>
      <button type="button" className="acao-topo ancora-conta" popoverTarget={idMenu}>
        <Icone nome="conta" />
        <span>Conta</span>
      </button>
      <div ref={ref} id={idMenu} popover="auto" className="flutuante flutuante-estreito flutuante-conta" role="dialog" aria-labelledby={`${id}-titulo`}>
        <div className="flutuante-cabeca">
          <h2 id={`${id}-titulo`}>Olá, {nome}</h2>
          <button type="button" className="acao-link" popoverTarget={idMenu} popoverTargetAction="hide">
            <Icone nome="fechar" />
            <span className="so-leitor">Fechar menu da conta</span>
          </button>
        </div>
        <ul className="flutuante-lista">
          <li><Link to="/app/conta" className="acao-link"><Icone nome="conta" />Minha conta</Link></li>
          <li><Link to="/app/enderecos" className="acao-link"><Icone nome="local" />Endereços</Link></li>
          <li><Link to="/app/formas-pagamento" className="acao-link"><Icone nome="cartao" />Formas de pagamento</Link></li>
          <li><Link to="/app/seguranca" className="acao-link"><Icone nome="protegido" />Segurança</Link></li>
          {trocaDeContexto && (
            <li className="so-celular">
              {trocaDeContexto.para === 'profissional'
                ? <Link to="/pro/inicio" className="acao-link"><Icone nome="trabalho" />Ir para a área de trabalho</Link>
                : <Link to="/" className="acao-link"><Icone nome="inicio" />Ir para a área de contratar</Link>}
            </li>
          )}
          {cadastroPro && (
            <li className="so-celular">
              <Link to="/pro/cadastro" className="acao-link"><Icone nome="trabalho" />{cadastroPro.rotulo}</Link>
            </li>
          )}
          {painel && <li><a href="/admin/conta" className="acao-link"><Icone nome="painel" />Painel da equipe</a></li>}
          <li><Link to="/novidades" className="acao-link"><Icone nome="info" />Novidades</Link></li>
          <li><Link to="/app/sugestoes" className="acao-link"><Icone nome="sugestao" />Sugestões</Link></li>
          <li className="flutuante-separado">
            <form onSubmit={(e) => { e.preventDefault(); aoSair(); }}>
              <button type="submit" disabled={saindo} className="acao-link">
                <Icone nome="sair" />
                {saindo ? 'Saindo…' : `Sair (${nome})`}
              </button>
            </form>
          </li>
        </ul>
      </div>
    </>
  );
}
